import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDriveTimeGeometry } from "features/MarketAreas/types";
import { resetMarketAreaDrawing } from "../resetMarketAreaDrawing";
import { generateDriveTimeArea } from "./controllers";

type TMarketAreaDriveTimeState = {
  drawnGeometry: IDriveTimeGeometry | null;
  editedGeometry: IDriveTimeGeometry | null;
  isGenerating: boolean;
  currentRequestId: string | null;
};

const initialState: TMarketAreaDriveTimeState = {
  drawnGeometry: null,
  editedGeometry: null,
  isGenerating: false,
  currentRequestId: null,
};

const marketAreaDriveTimeSlice = createSlice({
  name: "marketAreaDriveTime",
  initialState,
  reducers: {
    setDrawnDriveTime: (
      state,
      { payload }: PayloadAction<IDriveTimeGeometry | null>
    ) => {
      state.drawnGeometry = payload;
    },
    setDriveTimeEditedGeometry: (
      state,
      { payload }: PayloadAction<IDriveTimeGeometry | null>
    ) => {
      state.editedGeometry = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateDriveTimeArea.pending, (state, { meta }) => {
        state.currentRequestId = meta.requestId;
        state.isGenerating = true;
      })
      .addCase(generateDriveTimeArea.fulfilled, (state, { meta }) => {
        if (state.currentRequestId !== meta.requestId) return;
        state.currentRequestId = null;
        state.isGenerating = false;
      })
      .addCase(generateDriveTimeArea.rejected, (state, { meta }) => {
        if (state.currentRequestId !== meta.requestId) return;
        state.currentRequestId = null;
        state.isGenerating = false;
      })
      .addCase(resetMarketAreaDrawing, () => initialState);
  },
});

export const { setDrawnDriveTime, setDriveTimeEditedGeometry } =
  marketAreaDriveTimeSlice.actions;

export default marketAreaDriveTimeSlice;
